/* eslint-disable no-plusplus */
export function validateCedulaIdentidad(fileData, cara) {
  let retorno = null;
  return new Promise((resolve) => {
    switch (cara) {
      case 'CIA':
        if (isEmpty(fileData.nombres) && isEmpty(fileData.sexo)) {
          retorno = 'Ingrese el lado correcto de la cédula';
        } else if (!fileData.nombres || !fileData.cedula) {
          retorno =
            'Favor subir otra imagen. Te recomendamos evitar el uso de flash o imágenes con brillo excesivo.';
        }
        break;
      /* case 'CID':
        if (isEmpty(fileData.nacionalidad) && isEmpty(fileData.estadoCivil)) {
          retorno = 'Ingrese el lado correcto de la cédula';
        }
        break; */
      default:
        break;
    }
    resolve(retorno);
  });
}

export function validateCedulaVerde(fileData, cara) {
  let retorno = null;
  switch (cara) {
    case 'CVD': // Cedula Verde Detras
      if (
        isEmpty(fileData.marca?.descripcion) &&
        isEmpty(fileData.modelo?.descripcion)
      ) {
        retorno = 'Ingrese el lado correcto de la cédula verde';
      } else if (
        !fileData.marca?.descripcion
        // || !fileData.modelo?.descripcion
      ) {
        retorno =
          'Favor subir otra imagen. Te recomendamos evitar el uso de flash o imágenes con brillo excesivo';
      }
      break;
    case 'CVA': // Cedula Verde Adelante
      if (
        !fileData.cedulaVerdeFrontal &&
        fileData.codigoStatusVerificacion !== 0
      ) {
        retorno =
          'Favor subir otra imagen. Te recomendamos evitar el uso de flash o imágenes con brillo excesivo';
      }
      break;
    default:
      break;
  }
  return retorno;
}

export function validateChapaProvisoria(fileData) {
  let retorno = null;
  if (
    isEmpty(fileData.marca?.descripcion) &&
    isEmpty(fileData.modelo?.descripcion)
  ) {
    retorno = 'Ingrese el lado correcto de la cédula verde';
  } else if (!fileData.marca?.descripcion) {
    retorno =
      'Favor subir otra imagen. Te recomendamos evitar el uso de flash o imágenes con brillo excesivo';
  }
  return retorno;
}

export const isEmpty = (value) => {
  return value === null || value === undefined || value.length === 0;
};

export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};
